import { render, staticRenderFns } from "./ModalDisableUsers.vue?vue&type=template&id=20d8beba"
import script from "./ModalDisableUsers.vue?vue&type=script&lang=js"
export * from "./ModalDisableUsers.vue?vue&type=script&lang=js"
import style0 from "./ModalDisableUsers.vue?vue&type=style&index=0&id=20d8beba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports